import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "layer-selector__header" }
const _hoisted_2 = { class: "layer-selector__layers" }
const _hoisted_3 = { class: "layer-selector__menu" }
const _hoisted_4 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!
  const _component_SubLayerCheckbox = _resolveComponent("SubLayerCheckbox")!
  const _component_LayerCheckbox = _resolveComponent("LayerCheckbox")!
  const _component_TrafficSmallLegend = _resolveComponent("TrafficSmallLegend")!
  const _component_LayerCustom = _resolveComponent("LayerCustom")!
  const _component_ParkingGroupLegend = _resolveComponent("ParkingGroupLegend")!
  const _component_ArticleList = _resolveComponent("ArticleList")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass({'layer-selector': true, 'layer-selector--mobile-opened': _ctx.menuMobileIsOpen})
  }, [
    _createElementVNode("h1", _hoisted_1, [
      _createVNode(_component_translated_text_component, { translation: "nav_header_1" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.checkVal('EVENTS_ENABLE'))
        ? (_openBlock(), _createBlock(_component_LayerCheckbox, {
            key: 0,
            checked: _ctx.checkSomeEventActive(),
            small: _ctx.isSmall,
            icon: "events_switcher",
            label: "nav_events",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleEventsChange($event.target.checked))),
            tabIndex: 1
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventCategories, (category) => {
                return (_openBlock(), _createBlock(_component_SubLayerCheckbox, {
                  key: category.key,
                  checked: _ctx.eventLayers[category.key],
                  small: _ctx.isSmall,
                  icon: category.icon_code,
                  label: _ctx.checkHasTranslation(`EVENT_CATEGORY_NAME_${category.key}`) ? `EVENT_CATEGORY_NAME_${category.key}` : category.key,
                  onClick: _withModifiers(($event: any) => (_ctx.handleEventCategoryChange(category.key, $event.target.checked)), ["stop"]),
                  isDynamic: true,
                  hasTranslation: _ctx.checkHasTranslation(`EVENT_CATEGORY_NAME_${category.key}`)
                }, null, 8, ["checked", "small", "icon", "label", "onClick", "hasTranslation"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["checked", "small"]))
        : _createCommentVNode("", true),
      (_ctx.checkVal('EVENTS_ENABLE'))
        ? (_openBlock(), _createBlock(_component_LayerCheckbox, {
            key: 1,
            checked: _ctx.eventList,
            small: _ctx.isSmall,
            icon: "events_list_switcher",
            label: "nav_event_list",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleEventList($event.target.checked))),
            tabIndex: 2
          }, null, 8, ["checked", "small"]))
        : _createCommentVNode("", true),
      (_ctx.checkVal('TRAFFIC_ENABLE'))
        ? (_openBlock(), _createBlock(_component_LayerCheckbox, {
            key: 2,
            checked: _ctx.trafficLayer,
            small: _ctx.isSmall,
            icon: "traffic_switcher",
            label: "nav_traffic",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleTrafficChange($event.target.checked))),
            tabIndex: 3
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LayerCustom, {
                checked: true,
                small: _ctx.isSmall,
                parentState: _ctx.trafficLayer
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TrafficSmallLegend)
                ]),
                _: 1
              }, 8, ["small", "parentState"])
            ]),
            _: 1
          }, 8, ["checked", "small"]))
        : _createCommentVNode("", true),
      _createVNode(_component_LayerCheckbox, {
        checked: _ctx.checkSomeParkingLayerActive(),
        small: _ctx.isSmall,
        icon: "parking_switcher",
        label: "nav_parkings",
        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.handleAllParkingsLayersChange($event.target.checked)), ["stop"])),
        tabIndex: 4
      }, {
        default: _withCtx(() => [
          (_ctx.checkVal('PARKINGS_ENABLE'))
            ? (_openBlock(), _createBlock(_component_SubLayerCheckbox, {
                key: 0,
                checked: _ctx.parkingsLayer,
                small: _ctx.isSmall,
                parentState: _ctx.parkingsLayer,
                icon: "marker_parking",
                label: "nav_parkings",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleParkingsChange($event.target.checked)), ["stop"]))
              }, null, 8, ["checked", "small", "parentState"]))
            : _createCommentVNode("", true),
          (_ctx.checkVal('PARKING_SPOTS_ENABLE'))
            ? (_openBlock(), _createBlock(_component_SubLayerCheckbox, {
                key: 1,
                checked: _ctx.parkingSpotsLayer,
                small: _ctx.isSmall,
                parentState: _ctx.parkingsLayer,
                icon: "marker_parking_normal_spot",
                label: "subnav_parking_spaces",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleParkingSpotsChange($event.target.checked)), ["stop"]))
              }, null, 8, ["checked", "small", "parentState"]))
            : _createCommentVNode("", true),
          (_ctx.checkVal('PARKING_ZONE_ENABLE'))
            ? (_openBlock(), _createBlock(_component_SubLayerCheckbox, {
                key: 2,
                checked: _ctx.parkingZonesLayer,
                small: _ctx.isSmall,
                parentState: _ctx.parkingsLayer,
                icon: "marker_parking_zone",
                label: "subnav_parking_zones",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handleParkingZonesChange($event.target.checked)), ["stop"]))
              }, null, 8, ["checked", "small", "parentState"]))
            : _createCommentVNode("", true),
          (_ctx.checkVal('PARKING_METER_ENABLE'))
            ? (_openBlock(), _createBlock(_component_SubLayerCheckbox, {
                key: 3,
                checked: _ctx.parkingMetersLayer,
                small: _ctx.isSmall,
                parentState: _ctx.parkingsLayer,
                icon: "marker_parkometer",
                label: "subnav_parking_meters",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.handleParkingMetersChange($event.target.checked)), ["stop"]))
              }, null, 8, ["checked", "small", "parentState"]))
            : _createCommentVNode("", true),
          (_ctx.checkVal('PARKING_BOARD_ENABLE'))
            ? (_openBlock(), _createBlock(_component_SubLayerCheckbox, {
                key: 4,
                checked: _ctx.parkingBoardsLayer,
                small: _ctx.isSmall,
                parentState: _ctx.parkingsLayer,
                icon: "marker_parking_tip",
                label: "subnav_parking_boards",
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.handleParkingBoardsChange($event.target.checked)), ["stop"]))
              }, null, 8, ["checked", "small", "parentState"]))
            : _createCommentVNode("", true),
          _createVNode(_component_LayerCustom, {
            checked: _ctx.parkingsLayer,
            small: _ctx.isSmall,
            parentState: _ctx.parkingsLayer
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ParkingGroupLegend)
            ]),
            _: 1
          }, 8, ["checked", "small", "parentState"])
        ]),
        _: 1
      }, 8, ["checked", "small"]),
      (_ctx.checkVal('CAMS_ENABLE'))
        ? (_openBlock(), _createBlock(_component_LayerCheckbox, {
            key: 3,
            checked: _ctx.cameras,
            small: _ctx.isSmall,
            icon: "camera_switcher",
            label: "nav_cameras",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCamerasChange($event.target.checked))),
            tabIndex: 5
          }, null, 8, ["checked", "small"]))
        : _createCommentVNode("", true),
      (_ctx.checkVal('VMS_ENABLE'))
        ? (_openBlock(), _createBlock(_component_LayerCheckbox, {
            key: 4,
            checked: _ctx.vmsBoardsLayer,
            small: _ctx.isSmall,
            icon: "vms_board_switcher",
            label: "nav_vms",
            tabIndex: 8,
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleVmsBoardsChange($event.target.checked)))
          }, null, 8, ["checked", "small"]))
        : _createCommentVNode("", true),
      (_ctx.checkVal('POI_ENABLE'))
        ? (_openBlock(), _createBlock(_component_LayerCheckbox, {
            key: 5,
            checked: _ctx.checkSomePoiActive(),
            small: _ctx.isSmall,
            icon: "poi_switcher",
            label: "nav_poi",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handlePoiChange($event.target.checked))),
            tabIndex: 6
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.poiCategories, (category) => {
                return (_openBlock(), _createBlock(_component_SubLayerCheckbox, {
                  key: category.id,
                  checked: _ctx.poiLayer[category.id],
                  small: _ctx.isSmall,
                  icon: category.icon_code,
                  label: _ctx.checkHasTranslation(category.id) ? category.id : category.name,
                  onClick: _withModifiers(($event: any) => (_ctx.handlePoiCategoryChange(category.id, $event.target.checked)), ["stop"]),
                  isDynamic: true,
                  hasTranslation: _ctx.checkHasTranslation(category.id)
                }, null, 8, ["checked", "small", "icon", "label", "onClick", "hasTranslation"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["checked", "small"]))
        : _createCommentVNode("", true),
      (_ctx.checkVal('TRAVEL_ENABLE'))
        ? (_openBlock(), _createBlock(_component_LayerCheckbox, {
            key: 6,
            checked: _ctx.trackLayer,
            small: _ctx.isSmall,
            icon: "way_switcher",
            label: "nav_track",
            tabIndex: 9,
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleTrackChange($event.target.checked)))
          }, null, 8, ["checked", "small"]))
        : _createCommentVNode("", true),
      (_ctx.checkVal('WEATHER_STATIONS_ENABLE'))
        ? (_openBlock(), _createBlock(_component_LayerCheckbox, {
            key: 7,
            checked: _ctx.weatherStationsLayer,
            small: _ctx.isSmall,
            icon: "weather_station_switcher",
            label: "nav_meteo",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleWeatherStationsChange($event.target.checked))),
            tabIndex: 7
          }, null, 8, ["checked", "small"]))
        : _createCommentVNode("", true),
      (_ctx.checkVal('BIKE_STATIONS_ENABLE'))
        ? (_openBlock(), _createBlock(_component_LayerCheckbox, {
            key: 8,
            checked: _ctx.bikeStationsLayer,
            small: _ctx.isSmall,
            icon: "marker_bike",
            label: "nav_bike",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleBikeStationsChange($event.target.checked))),
            tabIndex: 10
          }, null, 8, ["checked", "small"]))
        : _createCommentVNode("", true)
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "layer-selector__breaker" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ArticleList)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["layer-selector__switch-mode", { 'layer-selector__switch-mode--opened': _ctx.menuMobileIsOpen }]),
      title: _ctx.menuMobileIsOpen ? 'Kliknij i zwiń menu' : 'Kliknij i rozwiń menu',
      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.menuMobileIsOpen =! _ctx.menuMobileIsOpen))
    }, _cache[16] || (_cache[16] = [
      _createElementVNode("i", { class: "mdi mdi-chevron-right" }, null, -1)
    ]), 10, _hoisted_4)
  ], 2))
}